import React from "react";
import TallyForm from "../components/TallyForm";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const Nominate = () => {
	return (
		<div className="pt-8">
			<Helmet>
				<title>Love on Trial | Nominate</title>
				<meta
					name="description"
					content="Nominate a friend for Love on Trial! Submit their details and help them find a match on our bold, values-driven dating show. Consent-first & private."
				/>
			</Helmet>
			{/* <Link to={"/"} className="absolute top-6 left-4 z-50 bg-white border text-sm rounded-lg px-5 py-2">
				Back
			</Link> */}
			<TallyForm
				url={"https://tally.so/r/3ljL6o?transparentBackground=1"}
				title="🎯 Matchmake Your Friends – Nomination Form"
			/>
		</div>
	);
};

export default Nominate;
